import { InputFieldAttributes } from '../mautic-form-types';
import { createFocusState, formatLabel } from '../utils';

export const Input = ({ fieldData }: { fieldData: InputFieldAttributes }) => {
    const {
        alias,
        defaultValue,
        errors,
        id,
        inputClasses,
        inputLabelClasses,
        isAutofill,
        leadField,
        isRequired,
        label,
        properties,
        type,
        value,
        handleChange,
        revalidate,
        errorInputClasses,
        errorLabelClasses,
        validationMessage,
        errorId,
    } = fieldData;
    const { isFocused, onFocus, onBlur } = createFocusState();
    const error = () => Boolean(errors[alias]);

    const stringID = String(id);

    const basePlaceholder =
        type === 'password' ? defaultValue ?? '' : type === 'datetime' ? new Date().toISOString().slice(0, 16) : properties?.placeholder ?? label;

    const placeholder = `${basePlaceholder}${isRequired ? ' *' : ''}`;

    return (
        <div class="relative">
            <label
                class={inputLabelClasses}
                classList={{
                    'top-xxs text-paragraphXS': isFocused() || !!value,
                    'sr-only': !isFocused() && !!value === false,
                    [errorLabelClasses || '']: error(),
                }}
                for={stringID}
            >
                {formatLabel(label, isRequired)}
            </label>
            <input
                {...(error() && { 'aria-invalid': true, 'aria-describedby': errorId })}
                {...(isAutofill && leadField && { autocomplete: leadField })}
                class={inputClasses}
                classList={{
                    'pt-s pb-xxs': isFocused() || !!value,
                    [errorInputClasses || '']: error(),
                }}
                id={stringID}
                onBlur={(e) => {
                    onBlur(e.target.value !== '');
                    revalidate(alias, e.target.value);
                }}
                onFocus={onFocus}
                onInput={(e) => handleChange(alias, e.target.value)}
                placeholder={!isFocused() ? placeholder : ''}
                value={typeof value === 'boolean' ? String(value) : value}
                type={type}
            />
        </div>
    );
};
